export const CAMPUS_DATA = {
  bugambilias: {
    slug: 'bugambilias',
    nombre: 'Bugambilias',
    ciudad: 'Jiutepec, Morelos',
    direccion: 'Geranio #309 Col. Vicente Estrada Cajigal C.p. 62460, Cuernavaca, Morelos',
    telefono: '777 330 3520 op. 2',
    whatsapp: '5576737753',
    placeId: 'ChIJE_0DExHfzYURlo2EGH35bJo',
    cita: 'Las bugambilias, con su vibrante manto de colores, son el símbolo perfecto de este campus lleno de vida y música.',
    descripcion:
      'Nuestro campus más grande en Morelos, ubicado en el corazón de Jiutepec. Contamos con salones acústicamente tratados, área de grabación y la mejor seguridad.',
    caracteristicas: ['6 cámaras exteriores', '32 cámaras interiores', 'Alarma vecinal', '9 micrófonos'],
    images: [
      require('../static/images/campus/buga-1.webp'),
      require('../static/images/campus/buga-2.webp'),
      require('../static/images/campus/buga-3.webp'),
    ],
    ruta: '/bugambilias',
    waFooter: '+5576737753',
    fb: 'https://www.facebook.com/LarghettoRMA',
    ig: 'https://www.instagram.com/larghetto.academia/',
    linkMaps: 'https://www.google.com.mx/maps/place/Larghetto+Academia+de+Arte+Musical/@18.9160694,-99.1960967,17.25z/data=!4m10!1m2!2m1!1slarghetto+bugambilias!3m6!1s0x85cddf111303fd13:0x9a6cf97d18848d96!8m2!3d18.9157991!4d-99.1951781!15sChVsYXJnaGV0dG8gYnVnYW1iaWxpYXOSAQxtdXNpY19zY2hvb2dgAQA!16s%2Fg%2F11j2cnrk8k?entry=ttu',
    flexReverse: false,
  },
  centro: {
    slug: 'centro',
    nombre: 'Centro',
    ciudad: 'Cuernavaca, Morelos',
    direccion: 'Miguel Salinas #5 Col. Centro C.p. 62000, Cuernavaca, Morelos',
    telefono: '777 399 1080 / 777 330 3520 op. 1',
    whatsapp: '7775341941',
    placeId: 'ChIJUzjadj7fzYUR3twB1gQYbmY',
    cita: 'Cuernavaca, la ciudad de la eterna primavera, es el hogar de nuestro campus Centro, un espacio de creatividad y aprendizaje.',
    descripcion:
      'En el corazón de Cuernavaca, a pasos del Jardín Borda. Instalaciones modernas con reja automática y tratamiento acústico profesional.',
    caracteristicas: ['2 cámaras exteriores', '18 cámaras interiores', 'Alarma vecinal', '6 micrófonos', 'Reja automática'],
    images: [
      require('../static/images/campus/centro-1.webp'),
    ],
    ruta: '/centro',
    waFooter: '+7775341941',
    fb: 'https://www.facebook.com/LarghettoRMA',
    ig: 'https://www.instagram.com/larghetto.academia/',
    linkMaps: 'https://www.google.com.mx/maps/place/Larghetto+Academia+de+Arte+Musical/@18.9232412,-99.2732495,14z/data=!4m10!1m2!2m1!1slarghetto!3m6!1s0x85cddf3e76da3853:0x666e1804d601dcde!8m2!3d18.9232459!4d-99.2382306!15sCglsYXJnaGV0dG-SAQxtdXNpY19zY2hvb2dgAQA!16s%2Fg%2F11fs0pbgvz?entry=ttu',
    flexReverse: true,
  },
  cuautla: {
    slug: 'cuautla',
    nombre: 'Cuautla',
    ciudad: 'Cuautla, Morelos',
    direccion: 'Sufragio Efectivo #52 Col. Emiliano Zapata C.p. 62744, Cuautla, Morelos',
    telefono: '735 152 2813 / 777 330 3520 op. 3',
    whatsapp: '5513168143',
    placeId: 'ChIJAw9ydRhvzoURrPC2R8E2Vhs',
    cita: 'Cuautla, tierra de historia y revolución, alberga nuestro campus más dinámico con explanada al aire libre.',
    descripcion:
      'A 3 minutos del centro de Cuautla. Edificio de 3 niveles con explanada de 280 m² para presentaciones al aire libre.',
    caracteristicas: ['16 cámaras vecinales', '4 cámaras exteriores propias', '20 cámaras interiores', 'Alarma vecinal'],
    images: [
      require('../static/images/campus/cuautla-1.webp'),
    ],
    ruta: '/cuautla',
    waFooter: '+5513168143',
    fb: 'https://www.facebook.com/LarghettoRMA',
    ig: 'https://www.instagram.com/larghetto.academia/',
    linkMaps: 'https://www.google.com.mx/maps/place/Larghetto+Academia+de+Arte+Musical/@18.8196446,-98.9480497,17z/data=!4m10!1m2!2m1!1slarghetto!3m6!1s0x85ce6f1875720f03:0x1b5636c147b6f0ac!8m2!3d18.8198676!4d-98.9469362!15sCglsYXJnaGV0dG-SAQZzY2hvb2zgAQA!16s%2Fg%2F11b77q25vj?entry=ttu',
    flexReverse: false,
  },
  coyoacan: {
    slug: 'coyoacan',
    nombre: 'Coyoacán',
    ciudad: 'CDMX',
    direccion: 'Av. Canal de Miramontes #1830, Col. Campestre Churubusco C.p. 04200, Coyoacán, CDMX',
    telefono: '55 9462 7062',
    whatsapp: '5521048568',
    placeId: 'ChIJHQqSBYL_0YURxVGlTz4HWVw',
    cita: 'Coyoacán, corazón cultural de la Ciudad de México, donde la música y el arte se encuentran.',
    descripcion:
      'Frente a la Terminal de Autobuses del Sur, metro Taxqueña. Smart TV 60", tratamiento acústico de alta densidad y espejos de gran formato.',
    caracteristicas: ['Smart TV 60"', 'Tratamiento acústico alta densidad', 'Espejos gran formato', 'Pisos laminados'],
    images: [
      require('../static/images/campus/coyoacan-1.webp'),
    ],
    ruta: '/coyoacan',
    waFooter: '+5521048568',
    fb: 'https://www.facebook.com/profile.php?id=61557665702420',
    ig: 'https://www.instagram.com/larghetto.academia/',
    linkMaps: 'https://www.google.com.mx/maps/place/Larghetto+Coyoac%C3%A1n/@19.3438505,-99.1720515,14z/data=!4m10!1m2!2m1!1slarghetto!3m6!1s0x85d1ff8205920a1d:0x5c59073e4fa551c5!8m2!3d19.3438505!4d-99.1370326!15sCglsYXJnaGV0dG-SAQxtdXNpY19zY2hvb2dgAQA!16s%2Fg%2F11vx2s672_?entry=ttu',
    flexReverse: true,
  },
};

export const CAMPUS_LIST = Object.values(CAMPUS_DATA);
